import axios from "axios";

export default {
  async getMe() {
    return axios.get(`/users/me`);
  },
  async updatePassword({ oldPassword, newPassword }) {
    return axios.patch(`/users/me/update-password`, {
      oldPassword,
      newPassword
    });
  }
};
